@if (loading()) {
  <app-loading />
} @else {
  <app-step-dot-menu
    [projectId]="projectId()!"
    testId="step4-1-x-dot-menu-button"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.EVALUATION_CRITERIA]"
  ></app-step-dot-menu>

  <div class="card mt-5" data-testid="evaluation-criteria-x-page">
    <app-card-title key="project.steps.evaluationCriteria.selectCriteria" />

    <app-badge-list
      [items]="badgeListItems()"
      [isOpenable]="false"
      data-testid="evaluation-criteria-x-table"
    ></app-badge-list>
  </div>

  <app-criteria-weighting-x
    class="block mt-5"
    translationKeyPrefix="project.steps.evaluationCriteria"
    identifierPrefix="EC"
    testId="evaluation-criteria-x-weighting"
    [items]="pairwiseItems()"
    [comparisons]="comparisons()"
    [weighting]="weighting()"
    [auditInfo]="auditInfo()"
    [disabled]="isButtonDisabled()"
    [saving]="isSaving()"
    (comparisonsSave)="onComparisonsSave($event)"
    (weightingSave)="onWeightingSave($event)"
  ></app-criteria-weighting-x>
}
